export const SIGNING_IN = 'SIGNING_IN'
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS'
export const SIGN_IN_FAILURE = 'SIGN_IN_FAILURE'
export const LOGOUT = 'LOGOUT'

export const TOKEN_VALIDATE_REQUEST = 'TOKEN_VALIDATE_REQUEST'
export const TOKEN_VALIDATE_SUCCESS = 'TOKEN_VALIDATE_SUCCESS'
export const TOKEN_VALIDATE_FAILURE = 'TOKEN_VALIDATE_FAILURE'